import Frame from "../Frames/Basic";
import SignInForm from "./components/SignInForm";

export default function Login(){

    return (
        <Frame center>
            
            <SignInForm />

        </Frame>
    )
}